// third-party
import { combineReducers } from "redux";

// project-imports
import menu from "./menu";
import snackbar from "./snackbar";
import dataSlice from "./dataSlice";
import layoutSlice from "./layoutSlice";
import customizationDataSlice from "./customizationDataSlice";

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  snackbar,
  data: dataSlice, // This reducer holds the API data and is persisted using redux-persist (as listed in persistConfig.whitelist)
  layout : layoutSlice,
  customizationData: customizationDataSlice
});

export default reducers;
